// Floating reactions (F-COM-3, design floatUp animation): emoji rise from the
// bottom of the stage at a deterministic horizontal position, gone in ≤3s
// (store expiry). Only this overlay subscribes to the reactions slice.

import { memo, useMemo } from 'react';

import { probeRender } from '../perf/renderProbe';
import { useCallStore } from '../store/callStore';

const Float = memo(function Float({ k, emoji, name }: { k: number; emoji: string; name: string }) {
  // Deterministic pseudo-random left offset per reaction (12%–82%).
  const style = useMemo(() => ({ left: `${12 + ((k * 37) % 71)}%` }), [k]);
  return (
    <div className="bz-reaction-float" style={style}>
      <span className="bz-reaction-emoji">{emoji}</span>
      <span className="bz-reaction-name">{name}</span>
    </div>
  );
});

export const ReactionsOverlay = memo(function ReactionsOverlay() {
  probeRender('ReactionsOverlay');
  const reactions = useCallStore((s) => s.reactions);
  if (reactions.length === 0) return null;
  return (
    <div className="bz-reactions-overlay" aria-hidden>
      {reactions.map((r) => (
        <Float key={r.key} k={r.key} emoji={r.emoji} name={r.name} />
      ))}
    </div>
  );
});
